import React, {Dispatch, SetStateAction} from 'react';
import BankTransferFormPersonal from "../../../../../components/BankTransferFormPersonal/BankTransferFormPersonal";

type PropsType = {
    setCurrent: Dispatch<SetStateAction<number>>
    current: number
    isButtonDisable: boolean | undefined
}

const BankTransferStepOne = (props: PropsType) => {

    return (
        <>
            <BankTransferFormPersonal
                setCurrent={props.setCurrent}
                isButtonDisable={props.isButtonDisable}
            />
        </>

    );

};

export default BankTransferStepOne;
